import { get } from 'lib/httpClient';
import { fetchWithCache } from 'lib/apiCache';

const RES_SETTING_CACHE_KEY = '/reservation_setting/retrieve';

const retrieve_reservation_setting = async (
  callback: ((data: any) => void) | null = null,
  options: { forceRefresh?: boolean } = {}
): Promise<void> => {
  const { forceRefresh = false } = options;
  const path = RES_SETTING_CACHE_KEY;
  const result = await fetchWithCache(path, () => get(path), forceRefresh);
  console.debug('retrieve_reservation_setting', result);
  if (callback !== null) {
    callback(result?.data);
  } else return result?.data;
};

export { retrieve_reservation_setting };
